// Open (or create) a 1:1 DM with the given email and switch the active
// channel to it. Used by the SharedPersonCard "Message" button on the chat
// home page so clicking a teammate's avatar takes you straight into a DM.
import { createChannel } from './createChannel.js'

export const messageUser = async function (email) {
  if (!email) return null
  // Reuse createChannel's existing dedupe logic — same emails sorted = same DM.
  const id = await createChannel.call(this, {
    kind: 'dm',
    memberEmails: [email]
  })
  if (!id) return null
  const root = this.state.root
  root.update({
    selectedPerson: null,
    activeChannelId: id,
    activeThreadRootId: null,
    activeTab: 'conversation'
  })
  return id
}
